<template>
  <div id="visorDeDocumento_div" >
      <div class="d-flex flex-wrap justify-content-center align-items-center">
        <div id="secciongeneral" v-if="obtenerRutaArchivoFinal != null" class="row">
          <!-- v-bind:style="{ top: topVisor + 'px' }" v-bind:class="[ esTesteo ? 'cTestar': 'cVisualizar']"-->
          <!-- Sección para modificar sentnecia -->
          <div v-if="esTesteo" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-3">
            <div class="areaLocal">
              <div id="encabezado-listado" class="form-inline justify-content-between">
                <h5 style="color:black;">Ingrese las palabras o frases a testar o edite la leyenda se sentencia</h5>
              </div>
              <hr class="mt-2" />
              <div class="d-flex row">
                <div class="col-12 text-left mb-2">
                    <button type="button" class="btn btn-primary overwrapDeBotones botonesVerde" @click="reiniciarDocumento()"><i class="fas fa-undo-alt fa-lg"></i>&nbsp;&nbsp;Reiniciar Documento</button>
                </div> 
              </div>
              <hr class="mt-2" />
              <!-- Apartado de para agregar palabras o frases para testar el documento -->
              <div style="color:black;">
                <div id="PalabraFrase_div">
                  <h6>Palabras o frases a testar</h6>
                  <div class="contenedor-puntero mt-1 mb-2 p-1">
                    <h6 class="mb-0" style="display:inline-block;"><i class="fas fa-info-circle"></i>&nbsp;Nota: </h6>
                    <span class="p-1" style="display:inline-block;">Asegúrese de ingresar palabras o frases completas considerando acentos, mayúsculas y minúsculas.</span>
                  </div>
                  <input 
                    type="text" 
                    id="palabraOFrase" 
                    class="form-control" 
                    placeholder="Ingrese una palabra o frase" 
                    v-model="palabraFraseAgregar" 
                    required
                  />
                </div>
                <div class="d-flex row">
                  <div class="col-12 text-right mt-2">
                      <button type="button" class="btn btn-primary overwrapDeBotones mb-1 botonesVerde" @click="agregarPalabraFrase()"><i class="fas fa-plus-square fa-lg"></i>&nbsp;&nbsp;Agregar</button>
                  </div> 
                </div>
                <div class="mt-2">
                  <table class="table table-striped table-light table-hover table-bordered table-condensed mt-2" id="tablaDeExpedientes_table" 
                        data-search="false" 
                        data-toggle="tablaDePalabrasFrasesATestar_table" 
                        data-pagination="false" 
                        data-toolbar="#tablaDePalabrasFrasesATestar_texto_div"
                        data-page-size="5"
                        data-page-list="[2,5,10]"
                        data-undefined-text="Sin información"
                        data-minimum-count-columns="0">
                      <thead style="background-color: var(--verde-pj)">
                          <tr>
                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%" class="text-center">#</th>
                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:80%" class="text-center">Palabra o frase a testar</th>
                            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%" class="text-center">Eliminar</th>
                          </tr>
                      </thead>
                      <tbody class="text-dark">
                          <tr v-if="!listadoPalabrasFrasesATestar || listadoPalabrasFrasesATestar.length <= 0">
                              <td colspan="3" class="text-center">No ha agregado ninguna palabra o frase aún</td>
                          </tr>
                          <tr v-for="(palabraFrase, index) in listadoPalabrasFrasesATestar" :key="'Palabra' + index">
                              <td class="text-center">{{index+1}}</td>
                              <td class="text-center">{{palabraFrase}}</td>
                              <td class="text-center">
                                  <i class="fas fa-trash-alt fa-lg" @click="eliminarPalabraFrase(index)" style="cursor:pointer;"></i>
                              </td>
                          </tr>
                      </tbody>
                  </table>
                </div>
              </div>
              <hr class="mt-2" />
              <!-- Apartado de certificado/leyenda de sentencia -->
              <div style="color:black;">
                <div id="LeyendaDeSentencia_div">
                  <h6>Certificado de sentencia</h6>
                  <div class="contenedor-puntero mt-1 mb-2 p-1">
                    <h6 class="mb-0" style="display:inline-block;"><i class="fas fa-info-circle"></i>&nbsp;Nota: </h6>
                    <span class="p-1" style="display:inline-block;">Asegúrese de que el certificado contenga la siguiente información: nombre del secretario(a), consecutivo, fecha de dictado, juez, número de fojas y descipción de la información suprimida.</span>
                  </div>
                  <textarea id="leyenda_txt" rows="6" style="width:100%" v-model="leyendaDeSentenciaTxtArea" class="form-control" @keyup="leyendaModificada()"> </textarea>
                </div>
              </div>
              <!-- Botón actualizar visor -->
              <div>
                <hr class="mt-2" />
                <div class="mt-2">
                  <div class="d-flex row">
                    <div class="col-12 text-right">
                        <button type="button" v-bind:class="[!documentoActualizadoListaPalabras || !documentoActualizadoLeyenda ? 'btn-success': 'btn-primary','btn overwrapDeBotones mb-1 botonesVerde']" @click="actualizarVisor()"><i class="fas fa-redo-alt fa-lg"></i>&nbsp;&nbsp;Actualizar Visor</button>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Sección mostrar Visor -->
          <div v-bind:class="[ esTesteo ? 'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-9': 'col-12','pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0']" >
            <div id="contenedor_apartado_visor" class="areaLocal" v-bind:class="[ esTesteo ? 'cTestar': 'cVisualizar']">
              <div v-if="esTesteo" id="encabezado-listado" class="form-inline justify-content-between">
                  <h5 style="color:black;">Vista previa de documento final.</h5>
              </div>
              <hr v-if="esTesteo" class="mt-2" />
              <!-- Componentes visor, cambia dependiendo de si es alta o consulta -->
              <div id="contenedor_componentes_visor" v-bind:class="[ esTesteo ? 'cTestarVisor': 'cVisualizarVisor']">
                <!--<div v-if="esConsulta" id="prueba">
                  <PDFV2 ref="myPdfComponent" :url="obtenerRutaArchivoFinal" :key="obtenerRutaArchivoFinal + keyVisor" :conImprimir="true" :conDescarga="true"></PDFV2>
                </div> 
                <PDFDocument v-else class="PDFDocument" :url="obtenerRutaArchivoFinal" :height="'100%'" :key="obtenerRutaArchivoFinal+keyVisor"></PDFDocument>-->
                <PDFDocument class="PDFDocument"                   
                  :height="'100%'" 
                  :EsBase64="EsBase64"
                  :key="obtenerRutaArchivoFinal + keyVisor"></PDFDocument>
              </div>
              <hr v-if="esTesteo" class="mt-2" />
              <!-- Botones guardar, regresar y cancelar -->
              <div v-if="esTesteo" class="d-flex row">
                <div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7 pb-2 text-left">
                    <button type="button" class="btn btn-danger overwrapDeBotones"  @click="cancelarAltaCambiosSentencia()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>
                    <button type="button"  class="btn btn-primary overwrapDeBotones botonesVerde"  @click="regresarAInformacionSentencia()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Regresar</button>                   
                </div> 
                <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-1 text-right">
                    <button id="btn-guardar" type="button" class="btn btn-success overwrapDeBotones mb-1" @click="guardarSentencia()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar y Publicar Sentencia</button>                    
                </div> 
                                
              </div>
              <!-- Opciones para descargar word testado y subir su versión en pdf. -->
              <div v-if="esTesteo" class="card">
                  <div class="card-header">
                    <h6><i class="fas fa-info-circle"></i>&nbsp;Nota.- En caso de que el documento que se muestra en el visor no este correcto:</h6>                    
                    <li>Paso 1. Descargar el documento Word testado.</li>
                    <li>Paso 2. Convertirlo en PDF.</li>
                    <li>Paso 3. Subir el documento PDF en su versión final (Sin marca de agua ni seguridad).</li>    
                  </div>    
                  <div class="card-body">              
                    <ul class="mb-0 pl-4">
                      <button type="button"  class="btn btn-primary overwrapDeBotones botonesVerde"  @click="descargarWordTestado(obtenerRutaWordTestado)"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;Descargar Archivo Word Testado</button>                                  
                      <br><br>
                      <div class="input-group">                                            
                              <input               
                                  type="file" 
                                  id="documento_pdf_testado" 
                                  ref="" 
                                  :class="'form-control'" 
                                  style="display:inline-block; height: auto !important;"                                
                                  v-on:change="pdfSeleccionado($event)" 
                                  accept=".PDF" 
                              />                                
                              &nbsp;&nbsp;
                              <div class="input-group-append">
                                <button type="button"  class="btn btn-primary overwrapDeBotones botonesVerde"  @click="subirPdfTestado()"><i class="fas fa-arrow-alt-circle-up fa-lg"></i>&nbsp;&nbsp;Subir Pdf Testado y Guardar Sentencia</button>
                              </div>                              
                      </div>
                    </ul>  
                  </div>               
                  </div>
              <!-- -->
            </div>
          </div>
        </div>   
      </div>
      <!-- Botón cerrar visor -->
      <div v-if="!esTesteo" class="d-flex flex-wrap justify-content-center align-items-center">
          <button id="cerrarElVisor" v-on:click="cierraElVisor()" class="btn btn-danger overwrapDeBotones"><i class="fas fa-times"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el documento</button>
      </div>
  </div>
</template>

<script>
import PDFDocument from '@/components/Comunes/PDFDocument.vue';
import PDFV2 from '@/components/Comunes/VisorPDFV2.vue';
import comun from "@/../static/js/comun";
import api from '@/../static/js/api'

export default {
  props: {
    esTesteo:false,
    esConsulta: false,
    listadoPalabrasFrasesATestar:null,
    leyendaDeSentencia:"", 
    consecutivoDeExpediente: "",    
    keyVisor:0,
    EsBase64:{
        esBase64:null,
        archivoBase64:null
    }
  },
  components: {
    PDFDocument,
    PDFV2
  }, 
  data(){
    return{
      documentoActualizadoListaPalabras: false,
      documentoActualizadoLeyenda: false,
      palabraFraseAgregar:"",
      listadoActualizadoPalabrasFrasesATestar:[],
      leyendaDeSentenciaTxtArea:"",
      leyendaDeSentenciaTxtAreaActualizada:"",
      //keyVisor:1,
      archivoPdf: null
    }
  },
  computed: {
    obtenerRutaArchivoFinal() {
      return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal;
    },
    obtenerRutaWordTestado() {
          return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado;
    }
  }, 
  /**
   * Método encargado de activar o desactivar elementos del visor, dependiendo de si es visor solamente o visor para testar.
   */
  mounted() {
    if(this.esTesteo && this.obtenerRutaArchivoFinal != undefined && this.obtenerRutaArchivoFinal != null)
    {
      this.documentoActualizadoListaPalabras = true;
      this.documentoActualizadoLeyenda = true;
      this.listadoActualizadoPalabrasFrasesATestar = [...this.listadoPalabrasFrasesATestar];
      if(this.leyendaDeSentencia)
      {
        this.leyendaDeSentenciaTxtArea = this.leyendaDeSentencia.slice();
        this.leyendaDeSentenciaTxtAreaActualizada = this.leyendaDeSentencia.slice();
      }
    }
    else if(this.obtenerRutaArchivoFinal == null)
    {
      bootbox.confirm({
        title: "Mensaje del sistema",
        message: "Ha ocurrido un error al cargar el archivo, favor de comunicarse al Área de Informatica.",
        buttons: {
          confirm: {
            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
          }
        },
        callback: (respuesta) => {
          if (respuesta) {
            this.listadoPalabrasFrasesATestar = [];
            this.documentoActualizadoListaPalabras = false;
            this.documentoActualizadoLeyenda = false;
            this.$emit("regresar");
          }
        }
      });
    }
  },
  methods: {
    /**
     * Selección un pdf testado 
     */
    pdfSeleccionado:function(evento){
      this.archivoPdf = evento.target.files[0];
      if(this.archivoPdf != null || this.archivoPdf != undefined)
      {            
        //$("#btn-guardar").removeClass('active');
        //$("#btn-guardar").addClass('disabled');     
        $("#btn-guardar").prop('disabled', true);      
      }      
    },
    /**
     * Método encargado de cerrar el visor
     */
    cierraElVisor: function() {
      //this.$store.dispatch('A_SICSEN_Sentencias_RutaArchivoFinal', null);
      /*this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal", null);
      this.$store.dispatch("A_SICSEN_Sentencias_EsBase64", null);*/
      this.$emit("regresar");
    },
    /**
     * Método encargado de comparar si la leyenda ha sido modificada
     */
    leyendaModificada:function()
    {
      this.documentoActualizadoLeyenda = (this.leyendaDeSentenciaTxtArea.localeCompare(this.leyendaDeSentenciaTxtAreaActualizada) == 0);
    },
    /**
     * Método encargado de agregar palabras o frases a listado para testar
     */
    agregarPalabraFrase:function()
    {
      if(this.palabraFraseAgregar) 
      {
        this.listadoPalabrasFrasesATestar.push(this.palabraFraseAgregar);
        this.palabraFraseAgregar = "";
        this.documentoActualizadoListaPalabras = false;
      }
      else comun.mensajeDeAlerta("No ha ingresado ninguna palabra o frase.", null, null);
    },
    /**
     * Método encargado de eliminar una palabra o frase del listado.
     */
    eliminarPalabraFrase:function(indexDeElemento)
    {
      if(indexDeElemento > -1) 
      {
          this.listadoPalabrasFrasesATestar.splice(indexDeElemento, 1);
          this.documentoActualizadoListaPalabras = false;
      }   
      else comun.mensajeDeAlerta("No se pudo eliminar el elemento seleccionado.", null, null);
    },
    /**
     * Método encargado de reiniciar el documento.
     */
    reiniciarDocumento:function()
    {
      if(this.listadoPalabrasFrasesATestar != undefined && this.listadoPalabrasFrasesATestar != null && this.listadoPalabrasFrasesATestar.length > 0)
      {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Al reiniciar el documento, todas las palabras y frases del listado se descartarán y se volverá al archivo original. <br />¿Desea continuar?",
          buttons: {
              cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y reiniciar'
              }
          },
          callback: (respuesta) => {
              if (respuesta) {
                this.listadoPalabrasFrasesATestar = [];
                this.leyendaDeSentenciaTxtArea = this.leyendaDeSentencia.slice();
                this.$emit("testarArchivo");
                this.documentoActualizadoListaPalabras = true;
                this.documentoActualizadoLeyenda = true;
              }
          }
        });
      }
    },
    /**
     * Método encargado de actualizar visor.
     */
    actualizarVisor:function()
    {
      if(!this.documentoActualizadoListaPalabras || !this.documentoActualizadoLeyenda)
      {        
        this.$emit("testarArchivo");
        this.listadoActualizadoPalabrasFrasesATestar = [...this.listadoPalabrasFrasesATestar];
        this.leyendaDeSentenciaTxtAreaActualizada = this.leyendaDeSentenciaTxtArea.slice();
        this.documentoActualizadoListaPalabras = true;
        this.documentoActualizadoLeyenda = true;
      }
    },
    /**
     * Método encargado de descargar un archivo word con la version testada de la sentencia
     */
    descargarWordTestado:function(rutaArchivo)
    {
      let target =false;
          let href = false;
          var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (target) ? "_blank" : '';
            a.href = (href) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
    },
    /**
     * Método subir un pdf ya testado
     */
    subirPdfTestado:function()
    {      
      if(this.archivoPdf == null || this.archivoPdf == undefined)
        comun.mensajeDeAlerta("Favor de seleccionar un archivo pdf.", null, null);
      else{
      bootbox.confirm({
        title: "Mensaje del sistema",
        message: "Está por guardar un archivo en su versión final. <br />¿Desea continuar?",
        buttons: {
          cancel: {
            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
          },
          confirm: {
            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y guardar'
          }
        },
        callback: (respuestaContinuar) => {
          if (respuestaContinuar) {            
              this.$emit("subirArchivo", true,true);
          }
        }
      });    
      }   
    },
    /**
     * Método encargado de cancelar alta cambios de sentencia
     */
    cancelarAltaCambiosSentencia:function()
    {
       bootbox.confirm({
        title: "Mensaje del sistema",
        message: "Si decide cancelar, perderá los cambios realizados y la información ingresada.<br />¿Desea continuar?",
        buttons: {
            cancel: {
            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
            },
            confirm: {
            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar'
            }
        },
        callback: (respuestaCancelar) => {
            if (respuestaCancelar) {
              this.$emit("cancelar");
            }
        }
      });
      
    },
    /**
     * Método encargado de ocultar visor y volver a componente de información de sentencia
     */
    regresarAInformacionSentencia: function()
    {
      if(this.esTesteo /*&& this.listadoPalabrasFrasesATestar!= undefined && this.listadoPalabrasFrasesATestar != null && this.listadoPalabrasFrasesATestar.length != this.listadoActualizadoPalabrasFrasesATestar.length*/)
      {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Si decide regresar, los cambios realizados en el listado de palabras o frases se perderán. <br />¿Desea continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Permanecer en visor'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Regresar'
            }
          },
          callback: (respuestaCancelar) => {
            if (respuestaCancelar) {
              this.listadoPalabrasFrasesATestar = null;
              this.listadoActualizadoPalabrasFrasesATestar = [];
              this.$emit("regresar");
            }
          }
        });
      }
    },
    /**
     * Método encargado de guardar una sentencia
     */
    guardarSentencia:function()
    {
      if(this.verificarLeyenda())
      {
        if(!this.documentoActualizadoListaPalabras || !this.documentoActualizadoLeyenda)
        {
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "No ha actualizado el visualizador, el archivo se guardará a la última versión acualizada. <br />¿Desea continuar?",
            buttons: {
                cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                },
                confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y guardar'
                }
            },
            callback: (respuesta) => {
                if (respuesta) {
                  this.$emit("guardar", this.listadoActualizadoPalabrasFrasesATestar.join('¶'));
                }
            }
          });
        }
        else this.$emit("guardar", this.listadoActualizadoPalabrasFrasesATestar.join('¶'));
      }
      
    },
    /**
     * Método encargado de verificar la leyenda o certificado.
     */
    verificarLeyenda:function()
    {
      //if(this.leyendaDeSentenciaTxtArea.includes("El(La) Licenciado(a)") || this.leyendaDeSentenciaTxtArea.includes("Secretario(a)") || this.leyendaDeSentenciaTxtArea.includes("Secretario(a)"))
      if(this.leyendaDeSentenciaTxtArea.includes("___"))
      {
        comun.mensajeDeAlerta("Falta uno o varios de los campos, verifique el certificado.", null, null);
        return false;
      }
      /*if(this.leyendaDeSentenciaTxtArea.includes("conste de ## fojas útiles"))
      {
        comun.mensajeDeAlerta("Falta el número de fojas.", null, null);
        return false;
      }*/
      /*if(this.leyendaDeSentenciaTxtArea.includes("El(La)") || this.leyendaDeSentenciaTxtArea.includes("Licenciado(a)") || this.leyendaDeSentenciaTxtArea.includes("Secretario(a)"))
      {
        comun.mensajeDeAlerta("Aseguresé de especificar el genero de el(la) secretario(a) al escribir la leyenda.", null, null);
        return false;
      }*/
      if(this.$store.getters.Get_AreaDelUsuario.AreaId != 27) /* 27 = SALA PENAL*/
      {
        const regexConsecutivo = /([0-9]{4})\/([0-9]{4})/g;
        var indexConsecutivo = this.leyendaDeSentenciaTxtArea.search(regexConsecutivo)
        var consecutivoIngresado = indexConsecutivo != -1 ? this.leyendaDeSentenciaTxtArea.substring(indexConsecutivo, indexConsecutivo + 9) : null;
        if(consecutivoIngresado == null || this.consecutivoDeExpediente.localeCompare(consecutivoIngresado) == 1)
        {
          comun.mensajeDeAlerta("El consecutivo no ha sido ingresado en el certificado o no coincide con el expediente, favor de verificarlo.", null, null);
          return false;
        }
      }
      return true;
    }
  }
}
</script>

<style scoped>
  .card {
    border: 1px solid rgb(129, 129, 129) !important;
    background: rgba(0,0,0,.7) !important;
  }
  #visorDeDocumento_div {
    position: absolute;
    top: -30px;
    left: -30px;
    right: -30px;
    min-height: calc(100% + 60px);
    height: auto;
    z-index: 6 !important;
    padding: 30px !important;
    background: rgba(0,0,0,.7);
    /*height: calc(100% + 60px);*/
  }
  /*.cVisualizar
  {
    height: calc(100% + 60px);
  }
  .cTestar
  {
    height: auto;
  }*/

  .cVisualizar
  {
    width: 80vw;
  }
  .cTestar
  {
    width: 99%;
  }

  .cVisualizarVisor
  {
    height: 80vh;
  }
  .cTestarVisor
  {
    height: 65vh;    
  }

  #cerrarElVisor {
    position: fixed;
    bottom: 0;
  }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 3vh;
  }
  h4 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 2vh;
  }

  .PDFDocument {
    /*width: 80vw;*/
    height: 100%;    
  }

  #contenedor_apartado_visor
  {
    /*width: 80%;*/
    /*min-height: 72vh;*/
    height: auto;
  }
  /*#contenedor_componentes_visor
  {
    
  }
  #visor-sentencias .modal-lg {
    max-width: 70% !important;
  }*/
  .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
  }
  #secciongeneral
  {
    position: fixed;
    bottom:1%;
    top: 10%;
    overflow-y:auto;
  }
  #prueba
  {
    overflow-y:scroll;
    height: 100%;
  }
  .areaLocal{
    background-color: var(--gris-pj-100);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
  }
  .botonesVerde{
    background-color: var(--verde-pj-100);
  }
</style>



// WEBPACK FOOTER //
// src/components/SICSEN/Comun/VisorTesteoSentencia.vue